/* eslint-disable import/export */
import { UsersState } from '@reducers/users';
import type { RootState } from '@src/store/reduxstore';
import { Selector } from '@types';

export const usersSelector: Selector<UsersState> = state => state.users;

export const userByIdSelector = (state: RootState) => (userId: number) =>
  state.users.items.find(user => userId && user?.id === userId);
